<template>
    <div>
        <Label class="mb-2" for="country">{{
            $t("billing.billing_information.country")
        }}</Label>

        <select
            id="countries"
            v-model="country"
            class="focus-with:ring-z-primary-100 w-full rounded-lg border-iron-300 py-[9px] text-sm outline-none focus-within:border-z-primary-300 focus-within:outline-none focus-within:ring-2 focus:outline-none focus:ring-z-primary-100"
            name="countries"
        >
            <option v-for="c of countries" :key="c.value" :value="c.value">
                {{ c.label }}
            </option>
        </select>
    </div>
</template>

<script setup lang="ts">
import { Label } from "@/components/ui/label";
import { countries } from "./countries";

const country = defineModel<string>();
</script>
